import React, { Component } from "react";
import { connect } from "react-redux";

import FirstCase from "../component/FirstCase";

import "../assets/css/style.css"

class BearbeitungsScreen extends Component {
    renderPreview() {
        if (this.props.case >= 0) {
          let currentCase = this.props.cases[this.props.kind][this.props.case];
          if (this.props.kind >= 0) {
            return (
              <FirstCase
                case={currentCase}
                vkind={this.props.kind}
                delete={() => this.deleteCurrentCase()}
              />
            );
          }
        }
      }

    render () {
      return (
          <div className="arbeitslisteScreen">
              <div className="arbeitslisteContainer">
                {console.log(this.props)}
                {this.renderPreview()}
              </div>
          </div>
      )
    }
}

const mapStateToProps = state => {
    return {
      cases: state.cases
    };
  };

export default connect(mapStateToProps)(BearbeitungsScreen)



// WEBPACK FOOTER //
// ./src/screens/BearbeitungsScreen.js